"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var helpers_1 = require("../../helpers");
var Icon_1 = require("../../Icon");
var Text_1 = require("../../Text");
var StackView_1 = require("../../StackView");
var View_1 = require("../../View");
var StyledIcon = styled_components_1.default(Icon_1.Icon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorLoginTitle;
});
var Title = styled_components_1.default(Text_1.Text)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: 28px;\n    line-height: 38px;\n    color: ", ";\n"], ["\n    font-size: 28px;\n    line-height: 38px;\n    color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorLoginTitle;
});
var WrapperContent = styled_components_1.default(View_1.View)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    background-color: #fff;\n    border-radius: ", ";\n    padding: ", ";\n"], ["\n    background-color: #fff;\n    border-radius: ", ";\n    padding: ", ";\n"])), helpers_1.SIZE_M, helpers_1.SIZE_L);
var OrText = styled_components_1.default(Text_1.Text)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    line-height: ", ";\n    color: ", ";\n"], ["\n    line-height: ", ";\n    color: ", ";\n"])), helpers_1.SIZE_XL, function (_a) {
    var theme = _a.theme;
    return theme.colorLoginTitle;
});
exports.SplashScreenFormBody = helpers_1.createUIElement('SplashScreenFormBody', function (_a, ref) {
    var className = _a.className, icon = _a.icon, title = _a.title, content = _a.content, texts = _a.texts, alternativeButton = _a.alternativeButton, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "icon", "title", "content", "texts", "alternativeButton", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (react_1.default.createElement(StackView_1.StackView, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'splash-form-body', className: "vm-SplashScreenFormBody " + className, align: StackView_1.STACK_ALIGN.center, distribution: StackView_1.STACK_DISTRIBUTION.start, direction: StackView_1.STACK_DIRECTION.column, gap: StackView_1.STACK_GAP.s, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        (icon || title) && (react_1.default.createElement(StackView_1.StackView, { align: StackView_1.STACK_ALIGN.center, direction: StackView_1.STACK_DIRECTION.column, gap: StackView_1.STACK_GAP.s, indentBottom: View_1.INDENT.m },
            icon && react_1.default.createElement(StyledIcon, { src: icon, size: Icon_1.ICON_SIZES.xxl }),
            title && react_1.default.createElement(Title, { truncate: true }, title))),
        react_1.default.createElement(WrapperContent, { contentMod: View_1.VIEW_CONTENT_MOD.fill }, content),
        alternativeButton && (react_1.default.createElement(StackView_1.StackView, { align: StackView_1.STACK_ALIGN.center, direction: StackView_1.STACK_DIRECTION.column, gap: StackView_1.STACK_GAP.s },
            react_1.default.createElement(OrText, { truncate: true, size: Text_1.TEXT_SIZE.xl }, (texts === null || texts === void 0 ? void 0 : texts.or) || 'Or'),
            alternativeButton))));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=SplashScreenFormBody.js.map